import React from 'react';
import { useSelector } from 'react-redux';

const DataFuelRecordsDetails = ({ rawDetailsData, dataType }) => {
    const standardFuels = ['MDO', 'LFO', 'HFO', 'LNG-ME', 'LNG-BOILER', 'LNG-AE', 'LNG-OTHERS', 'LPG-PROPANE', 'LPG-BUTANE', 'VLSFO'];
    let data = {
        "Standard Fuels": rawDetailsData.filter(item => standardFuels.includes(item.fuel_id__name)),
        "Alternate Fuels": rawDetailsData.filter(item => !standardFuels.includes(item.fuel_id__name))
    };

    console.log(dataType)



    const renderFuels = (fuels) => {
        const columns = [];
        for (let i = 0; i < fuels.length; i += 2) {
            columns.push(fuels.slice(i, i + 2));
        }

        return columns.map((column, columnIndex) => (
            <div key={columnIndex} style={{ display: 'flex', flexDirection: 'column', marginRight: '30px', gap: '20px' }}>
                {column.map((item, index) => (
                    <div key={index} style={{ marginBottom: '25px' }}>
                        <p className='data_labels' style={{ display: 'block' }}>{!item.fuel_id__name ? '-' : item.fuel_id__name}</p>
                        <p className='data_values' style={{ display: 'block' }}>
                            {(() => {
                                let value;
                                switch (dataType.requestedData) {
                                    case 'ROB_DATA':
                                        value = `${item.rob || item.rob == 0 ? item.rob : '-'}`;
                                        break;
                                    case 'FUEL_CONSUMPTION_DATA':
                                        value = `${item.consumption || item.consumption == 0 ? item.consumption : '-'}`;
                                        break;
                                    case 'BUNKER_SURVEY_DATA':
                                        value = `${item.bunker_survey || item.bunker_survey == 0 ? item.bunker_survey : '-'}`;
                                        break;
                                    case 'BUNKER_QTY_DATA':
                                        value = `${item.bunker_quantity || item.bunker_quantity == 0 ? item.bunker_quantity : '-'}`;
                                        break;
                                    case 'LCV_DATA':
                                        value = `${item.fuel_metadata__lcv || item.fuel_metadata__lcv == 0 ? item.fuel_metadata__lcv : '-'}`;
                                        break;
                                    case 'CSLIP_DATA':
                                        value = `${item.fuel_metadata__cslip || item.fuel_metadata__cslip == 0 ? item.fuel_metadata__cslip : '-'}`;
                                        break;
                                    case 'EF_TTW_DATA':
                                        value = dataType.selected_button === 'MJfuel'
                                            ? `${item.fuel_metadata__ef_ttw_MJfuel || item.fuel_metadata__ef_ttw_MJfuel == 0 ? item.fuel_metadata__ef_ttw_MJfuel?.toFixed(2) : '-'}`
                                            : `${item.fuel_metadata__ef_ttw_gfuel || item.fuel_metadata__ef_ttw_gfuel == 0 ? item.fuel_metadata__ef_ttw_gfuel?.toFixed(2) : '-'}`;
                                        break;
                                    case 'EF_WTT_DATA':
                                        value = dataType.selected_button === 'MJfuel'
                                            ? `${item.fuel_metadata__ef_wtt_MJfuel || item.fuel_metadata__ef_wtt_MJfuel == 0 ? item.fuel_metadata__ef_wtt_MJfuel?.toFixed(2) : '-'}`
                                            : `${item.fuel_metadata__ef_wtt_gfuel || item.fuel_metadata__ef_wtt_gfuel == 0 ? item.fuel_metadata__ef_wtt_gfuel?.toFixed(2) : '-'}`;
                                        break;
                                    default:
                                        value = '-';
                                        break;
                                }
                                return value ?? '-';
                            })()}
                        </p>
                    </div>
                ))}
            </div>
        ));
    };

    return (
        <div style={{ display: 'flex', marginTop: '15px' }}>
            <div style={{ display: 'flex' }}>
                <div style={{ marginRight: '30px', borderRight: '0.5px solid #BEBEBE' }}>
                    <p className='data_heading'>Standard Fuels {dataType.requestedData === "LCV_DATA" ? "(MJ/MT)" : dataType.requestedData === "EF_TTW_DATA" || dataType.requestedData === "EF_WTT_DATA" ? "(gCO₂eq/MJ)" : '(MT)'}</p>
                    <div style={{ display: 'flex' }}>
                        {renderFuels(data["Standard Fuels"])}
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex' }}>
                <div>
                    <p className='data_heading'>Alternate Fuels {dataType.requestedData === "LCV_DATA" ? "(MJ/MT)" : dataType.requestedData === "EF_TTW_DATA" || dataType.requestedData === "EF_WTT_DATA" ? "(gCO₂eq/MJ)" : '(MT)'}</p>
                    <div style={{ display: 'flex' }}>
                        {renderFuels(data["Alternate Fuels"])}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DataFuelRecordsDetails;
